import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import StatementsOfWork from "../components/StatementsOfWork";
import * as projectActions from "./../../../../../actions/project.actions";
import * as commonActions from "./../../../../../actions/common.actions";
import * as userActions from "./../../../../../actions/user.actions";

const subHeader = {
  items: [
    {
      caption: "Matches",
      url: "/member/projects/matches"
    },
    {
      caption: "Pitches",
      url: "/member/projects/pitches"
    },
    {
      caption: "SOWs",
      url: "/member/projects/sows"
    },
    {
      caption: "Completed",
      url: "/member/projects/completed"
    },
    {
      caption: "Invoices",
      url: "/member/projects/invoices"
    }
  ],
  activeItem: 2,
  track: true
};

class StatementsOfWorkContainer extends Component {
  constructor(props) {
    super(props);

    props.projectActions.getStatus();
    props.projectActions.getPitches();

    this.completeProject = this.completeProject.bind(this);
    this.getProjectStatusOfPitch = this.getProjectStatusOfPitch.bind(this);

    if (_.isEmpty(this.props.stats)) {
      this.props.userActions.getUserStats(2);
    }
  }

  componentDidMount() {
    this.props.commonActions.setSubHeader(subHeader);
  }

  componentWillUnmount() {
    this.props.commonActions.setSubHeader({});
  }

  completeProject(projectId) {
    this.props.projectActions.completeProjectByMember(projectId);
  }

  getProjectStatusOfPitch(pitch) {
    const projectStatusWhiteList = {
      sow: "sow",
      "in-progress": "in-progress"
    };

    const projectStatusName = _.get(
      _.find(this.props.project.status, {
        id: _.get(pitch, "match.project.status_id")
      }),
      "slug"
    );

    return projectStatusWhiteList[projectStatusName];
  }

  getAcceptedPitches() {
    const pitches = _.get(this.props, "project.pitches");

    return _.filter(pitches, pitch => {
      if (!pitch.accepted) {
        return false;
      }

      return this.getProjectStatusOfPitch(pitch);
    });
  }

  render() {
    const acceptedPitches = this.getAcceptedPitches();

    return (
      acceptedPitches && (
        <StatementsOfWork
          acceptedPitches={acceptedPitches}
          completeProject={this.completeProject}
          getProjectStatusOfPitch={this.getProjectStatusOfPitch}
        />
      )
    );
  }
}

const mapStateToProps = state => {
  return {
    project: state.project,
    stats: state.user.stats
  };
};

const mapDispatchToProps = dispatch => {
  return {
    projectActions: bindActionCreators(projectActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    userActions: bindActionCreators(userActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StatementsOfWorkContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/projects/statementsOfWork/containers/StatementsOfWorkContainer.js